import React, { useEffect, useMemo, useState } from "react";
import "../style/Post/post.scss";
import { Link } from "react-router-dom";
import ApiContent from "../api/ApiContent";
import IconComponent from "./Icons";
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import ApiComment from "../api/ApiComment";
import Swal from "sweetalert2";
import CSwl from "../utils/alert";
import Comment from './Comment'
import { WEB_IMAGE } from "../env";
import { ConvertDateShort } from "../utils/date";
import { useHistory } from 'react-router-dom'
import { Player } from 'video-react';
import ReactQuill from "react-quill";
import html2pdf from "html2pdf.js";
import { faBookmark } from '@fortawesome/free-regular-svg-icons';
import { faEllipsisH, faBookmark as faBookmarkSolid } from '@fortawesome/free-solid-svg-icons';
import { useClipboard } from 'use-clipboard-copy';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ApiLog from "../api/ApiLog";
import PostContentGroup from "./PostContentGroup";
import PostContentGroupDetailNoEmployee from "./PostContentGroupDetailNoEmployee";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { arrayIncludesArray } from "../utils";
const PostContentGroupDetail = ({
  name,
  image,
  imageComment,
  time,
  title,
  detail,
  subdetail,
  totalLike,
  totalComment,
  page,
  contentid,
  isLike,
  isBookmark,
  contentStyles,
  isComment = false,
  isCommentFirst = true,
  comments = [],
  item,
  onComment = () => { },
  onRead = () => { }
}) => {
  const { t, i18n } = useTranslation();
  const modules = useMemo(
    () => ({
      toolbar: false
    }),
    []
  );
  const userState = useSelector((state) => state.user);
  const [contentRef, setContentRef] = useState([]);
  const [contentRefUser, setContentRefUser] = useState([]);
  const [tags, settags] = useState([]);
  const [videos, setvideos] = useState([]);
  const [docs, setdocs] = useState([]);
  const history = useHistory();
  const clipboard = useClipboard({ copiedTimeout: 800 });
  const [catalogs, setcatalogs] = useState([]);
  useEffect(() => {
    func_setData();
    if (item?.cttagtJson && item.cttagtJson != "[]") {
      let tags = JSON.parse(item.cttagtJson);

      settags(tags.map(x => x.Name));
    }
    if (item?.ctfilevideo && item.ctfilevideo != "[]") {
      let videos = JSON.parse(item.ctfilevideo);
      console.log(videos.map(x => process.env.REACT_APP_IMAGE + x.Path))
      setvideos(videos.map(x => process.env.REACT_APP_IMAGE + x.Path));
    }
    if (item?.ctfiledoc && item.ctfiledoc != "[]") {
      let docs = JSON.parse(item.ctfiledoc);
      setdocs(docs);
    }
    if (item?.refJson && item?.refJson != "[]") {
      setContentRef(JSON.parse(item.refJson));
    }
    if (item?.refUserJson && item?.refUserJson != "[]") {
      setContentRefUser(JSON.parse(item.refUserJson));
    }
    if (item.ctcatagoryJson != "[]") {
      let catagory = JSON.parse(item.ctcatagoryJson);
      setcatalogs(catagory.map(x => x.Name));
    }
  }, []);

  //state
  const [like, setLike] = useState(0);
  const [pIsLike, setPisLike] = useState(false);
  const [pIsBookMark, setPisBookmark] = useState(isBookmark);
  const [spam, setspam] = useState(false);
  const [options, setOptions] = useState(false);
  const [isModal, setisModal] = useState(false);
  const [spamValue, setspamValue] = useState('spam');
  const [spamNote, setspamNote] = useState('');
  const [spamFormError, setspamFormError] = useState("");
  const [state, setstate] = useState({
    "contentId": contentid,
    "comment": ""
  })

  const [replyState, setreplyState] = useState({
    commentId: 0,
    createby: 0
  })

  const func_setData = () => {
    setLike(totalLike);
    setPisLike(isLike);
  };

  const func_like = async () => {
    const result = await ApiContent.Like(contentid);
    if (result.status == 200) {
      if (result.data.statusLike) {
        setLike(like + 1);
        setPisLike(true);
      } else {
        setLike(like - 1);
        setPisLike(false);
      }
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      state.replyToCommentId = replyState.commentId;
      state.replyToUser = replyState.createby;
      const created = await ApiComment.create(state);
      if (created.status == 200) {
        setstate({ ...state, comment: "" })
        onComment(created.data);
      }
    } catch (error) {
      const { data } = error.response;
      CSwl.SwalErr(data.title)
    }
  }

  const reply = async (comment) => {
    const input_comment = document.getElementById('input_comment');
    input_comment.focus();
    setreplyState({ commentId: comment.id, createby: comment.createby });
    setstate({ ...state, comment: `<a href="${window.location.origin}/profileDetail?id=${comment.createby}">@${comment.fullNameEng}</a>` })
  }

  const func_bookmark = async (e) => {
    // CSwl.SwalLoad();
    e.stopPropagation();
    const result = await ApiContent.Bookmark(item.id);
    if (result.status == 200) {
      if (result.data.statusBookmark) {
        setPisBookmark(true);
      } else {
        setPisBookmark(false);
      }
    }
    // CSwl.SwalClose();
  };

  // const _exportPdf = () => {
  //   var element = document.getElementById('element-to-print');
  //   window.html2pdf(element);
  // }

  const _exportPdf = async () => {
    var element = document.getElementById('element-to-print');
    const opt = {
      margin: 20,
      filename: title,
      //image: { type: 'jpeg', quality: 1 },
      // html2canvas: { scale: 3 },
      html2canvas: { dpi: 192, letterRendering: true },
      //jsPDF: { orientation: 'portrait', unit: 'pt', format: 'a4' },
      image: { type: 'jpeg', quality: 0.98 },
      // filename: 'report.pdf',
      // html2canvas: { scale: 3 },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
    };


    // html2pdf().set(opt).from(element).save();

    html2pdf().from(element).set(opt).toPdf().get('pdf').then((pdf) => {
      var totalPages = pdf.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        // set footer to every page
        pdf.setPage(i);
        // set footer font
        pdf.setFont("helvetica");
        pdf.setFontSize(10);
        pdf.setTextColor(150);
        // this example gets internal pageSize just as an example to locate your text near the borders in case you want to do something like "Page 3 out of 4"
        pdf.text(pdf.internal.pageSize.getWidth() - 30,
          pdf.internal.pageSize.getHeight() - 10, 'YOUR TEXT GOES HERE!');

        // you can add the line separator as an image, consult the docs below to properly set the place of the image
        // pdf.addImage(img, 'png', 0, 0, 52, 23)
      }
    }).save();
  }

  const renderBookmarkButton = () => {
    return <div
      className="pl-2 is-flex is-align-items-center is-absolute is-right-0 is-top-20 pr-5 pt-0"
    >
      <div style={{ cursor: "pointer" }} onClick={(e) => {
        func_bookmark(e);
      }}>
        {pIsBookMark ? (
          // <img
          //     className="img-size"
          //     src={process.env.PUBLIC_URL + "/images/firstPage/Like.png"}
          //     alt="Like2"
          //     width="16"
          //     height="16"
          // />
          <IconComponent
            className="icon-20x ml-3" color="#000"
            icon={faBookmarkSolid}
          />
        ) : (
          <IconComponent
            className="icon-20x ml-3" color="#000"
            icon={faBookmark}
          />
        )}
      </div>
      <div style={{ position: 'relative' }}>
        <div className="cursor-pointer" onClick={(e) => {
          e.stopPropagation();
          setspam(!spam);
        }}>
          <IconComponent
            className="icon-20x ml-3" color="#333"
            icon={faEllipsisH}
          />
        </div>
        {spam && <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="spam-container">
          <ul>
            <li className="cursor-pointer" onClick={(e) => {
              e.stopPropagation();
              setisModal(true);
              setspamFormError("");
              setspam(false);
            }}>รายงานโพสต์นี้</li>
          </ul>
        </div>
        }

      </div>
    </div>
  }

  const renderEditButton = () => {
    return <div
      className="pl-2 is-flex is-align-items-center is-absolute is-right-0 is-top-10 p-5"
    >
      <div style={{ position: 'relative' }}>
        <div className="cursor-pointer" onClick={(e) => {
          e.stopPropagation();
          setOptions(!options);
        }}>
          <IconComponent
            className="icon-20x ml-3" color="#333"
            icon={faEllipsisH}
          />
        </div>
        {options && <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="spam-container">
          <ul>
            <li className="cursor-pointer" onClick={(e) => {
              e.stopPropagation();
              history.push(`editcontent?c=${item.id}`);
            }}>แก้ไขโพสต์นี้</li>
          </ul>
        </div>
        }

      </div>
    </div>
  }

  const _sharePdf = async (e) => {
    const url = `${window.location.href}`;
    clipboard.copy(url);
  }

  const spamPost = async (e) => {
    e.stopPropagation();
    if (spamNote) {
      const result = await ApiContent.Spam({
        ctid: item.id,
        spamCode: spamValue,
        spamNote: spamNote
      });
      if (result.status == 200) {
        setspamValue('spam');
        setspamNote("")
        setisModal(false);
        CSwl.SwalSuccess("รายงานโพสต์นี้เรียบร้อยแล้ว")
      }
    } else {
      setspamFormError("กรุณากรอกเหตุผลในการรายงาน")
    }


  }

  const downloadFileLog = async (item) => {
    try {
      await ApiLog.downloadfile({
        page: contentid.toString(),
      });
    } catch (error) {

    }
    window.open(`${process.env.REACT_APP_IMAGE}${encodeURIComponent(item.Path).replace("%2F", "/")}`, '_blank')
  }





  var submitEl = React.useRef(null);

  const renderVerified = () => {
    const smeCategory = userState.employee.smeCategory;
    if (item.isReview == 1 && userState.isAdmin) {
      return <Badge label="Verified" type="verified" />;
    }
    else if (item.isReview == 1 && (smeCategory && arrayIncludesArray(smeCategory.split(','), catalogs))) {
      return <Badge label="Verified" type="verified" />;
    }
    else {
      <></>
    }
  }



  return (
    <div id="post-com" key={contentid} className="card">
      {
        (item.profileid !== userState.profile.id) && renderBookmarkButton()
      }
      {
        (item.profileid == userState.profile.id) && renderEditButton()
      }
      <div className="content container-header">
        <div className="media is-justify-content-space-between is-align-items-center">
          <div className="media pt-5" style={{ borderTop: 0 }}>
            <div>
              <figure className="image is-48x48">
                <img
                  style={{ height: '100%', width: '100%' }}
                  alt={'image_profile'}
                  className="is-rounded image-cover cursor-pointer"
                  src={image}
                  onClick={() => history.push(
                    userState.profile.id == item.profileid ?
                      "/profile" :
                      `/profileDetail?id=${item.profileid}`
                  )}
                />
              </figure>
            </div>
            <div className="media-content title-header">
              <span onClick={() => history.push(
                userState.profile.id == item.profileid ?
                  "/profile" :
                  `/profileDetail?id=${item.profileid}`
              )} className="has-text-weight-bold cursor-pointer">{name}</span>
              <span className="has-text-grey-light">{time}</span>
            </div>
          </div>
          {/* <div className="is-flex is-align-items-center mr-3">
            <img
              className="mx-2"
              src={process.env.PUBLIC_URL + "/images/Menu/Vector.png"}
              alt="logo1"
              width="18"
              height="24"
            />
            <img
              className="mx-2"
              src={process.env.PUBLIC_URL + "/images/Menu/Vector6_grey.png"}
              alt="logo1"
              width="24"
              height="4"
            />
          </div> */}
        </div>
      </div>
      <div id="element-to-print">
        <div>
          <div className="container-header content p-4 flex gap-x-2 items-center">
            <h3 className="has-text-link m-3 has-text-weight-bold">{title}</h3>
            {
              renderVerified()
            }
            <Badge label="Knowledge Path" type="knowledgePath" />
          </div>
          {item.coverimage &&
            <div class="column d-flex is-align-items-center is-justify-content-center pt-5">
              <img src={`${process.env.REACT_APP_IMAGE}${item.coverimage}`} alt="image_content" class="size-img"></img>
            </div>
          }
          <div style={{ minHeight: 'inherit' }} className="ql-editor pt-0" >
            <p
              style={contentStyles}
              className='subtitle-c-p mx-3'
              dangerouslySetInnerHTML={{ __html: detail }}
            />
            {page !== 'detail' &&
              <div className="mt-2 mx-3">
                <Link to={`/contentDetail?id=${contentid}`}>
                  <span className="has-text-danger">อ่านต่อ </span>
                </Link>
              </div>
            }
          </div>
          {
            item.contentGroupList && item.contentGroupList.length > 0 && <div className="p-3 gap-y-2 flex flex-column">
              {
                item.contentGroupList.map((d, index) => {
                  return <div className={`border flex flex-wrap rounded-lg relative ${d.isRead ? "border-[#f97316]" : ""}`}>
                    <div className={`sm:w-32 hidden  border sm:flex rounded-tl-lg rounded-bl-lg items-center justify-center ${d.isRead ? "bg-[#f97316] text-white border-[#f97316]" : ""}`}>
                      <div className="sm:text-2xl">{index + 1}</div>
                    </div>
                    <div className="flex flex-1 gap-x-4 items-center">
                      <div className="flex gap-x-1">
                        {/* <span className={`${d.isRead ? "bg-[#f97316] text-white" : "bg-white text-black border"} px-3 py-1 rounded-full shadow-lg text-sm font-semibold`}>
                          {index + 1}
                        </span> */}
                      </div>
                      <PostContentGroupDetailNoEmployee
                        time={ConvertDateShort(d.cttrandate, "DD MMM YYYY HH:mm น.")}
                        totalLike={d.ctlikeAmt}
                        isLike={d.isLike}
                        isBookmark={d.isBookmark}
                        item={d}
                        title={d.ctname}
                        comments={[]}
                        detail={d.ctdeschtml}
                        name={`${d.employee?.firstNameEnglish} ${d.employee?.lastNameEnglish}`}
                        image={
                          d.imageProfile
                            ? process.env.REACT_APP_IMAGE + d.imageProfile
                            : process.env.PUBLIC_URL +
                            "/images/profilePage/Profile.png"
                        }
                        onDelete={null}
                      />
                      <div className="flex gap-x-1 flex-column">
                        <div className="is-flex">
                          {
                            d.isRead ? <button
                              onClick={() => {
                                window.open(`/contentDetail?id=${d.id}`, '_blank');
                                setTimeout(() => {
                                  onRead();
                                }, 3000);
                              }
                              }
                              type="button"
                              disabled={
                                (index > 0) ? (item.contentGroupList[index - 1].isRead ? false : true)
                                  : false
                              }
                              className="button min-w-[150px] !bg-[#f97316] !text-white is-outlined has-text-weight-bold has-background-light subtitle-p4 mx-2"
                            >
                              <CheckCircleIcon className="mr-1" height={30} width={30} />
                              {t('text.learning_path_button_readed')}
                            </button>
                              : <button
                                onClick={() => {
                                  window.open(`/contentDetail?id=${d.id}`, '_blank');
                                  setTimeout(() => {
                                    onRead();
                                  }, 3000);
                                }
                                }
                                type="button"
                                disabled={
                                  (index > 0) ? (item.contentGroupList[index - 1].isRead ? false : true)
                                    : false
                                }
                                className="button min-w-[150px] !bg-[#3b82f6] !text-white is-outlined has-text-weight-bold has-background-light subtitle-p4 mx-2"
                              >
                                {t('text.learning_path_button_read')}
                              </button>

                          }

                        </div>

                      </div>
                    </div>
                    {/* {
                      d.isRead && <div className="absolute bottom-5 right-5 text-center">{t("text.learning_path_readed")}</div>
                    } */}
                  </div>

                })
              }
            </div>
          }

        </div>
      </div>
      {docs.length > 0 &&
        <div className="d-flex p-5 flex-column">
          {docs && docs.map((item, index) => {
            return (
              <div onClick={() =>
                downloadFileLog(item)

              } className="file-container w-100">
                {item.Name}
              </div>
            )
          })}
        </div>
      }





      <div className="d-flex">
        {videos && videos.map((item, index) => {
          return (
            <Player>
              <source src={item} />
            </Player>
          )
        })}
      </div>
      <div className="mt-2 d-flex flex-wrap">
        {tags && tags.map((item, index) => {
          return (
            <div style={{ marginTop: 10 }} onClick={() => {
              history.push(`/tag?q=${item}`);
            }}
              className="pl-5 is-flex is-align-items-center">
              <span className="cursor-pointer is-size-7 tag">{item}</span>
            </div>
          )
        })}
      </div>
      {(contentRef && contentRef.length > 0) &&
        <>
          <div className="d-flex flex-column p-5">
            <label className="has-text-weight-semibold">โครงการอ้างอิง</label>
            {
              contentRef.map((item, index) => {
                return (
                  <div style={{ marginTop: 10 }} className="is-flex is-align-items-center">
                    <div
                      onClick={(e) => {
                        //  history.replace(`contentDetail?id=${item.id}`)
                        window.location.href = `contentDetail?id=${item.id}`;
                      }}
                      className="tag cursor-pointer" style={{ fontSize: 12, whiteSpace: 'initial', height: 'auto' }}>
                      <span>{item.ctname}</span>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </>
      }
      {(contentRefUser && contentRefUser.length > 0) &&
        <>
          <div className="d-flex flex-column" style={{ paddingLeft: '1.5rem', paddingRight: '1.5rem' }}>
            <label className="has-text-weight-semibold">{t('text.referal')}</label>
            <div className="d-flex">
              {
                contentRefUser.map((item, index) => {
                  return (
                    <div style={{ marginTop: 10 }} className="is-flex is-flex-directions-row is-align-items-center mr-2">
                      <div
                        onClick={(e) => {
                          //  history.replace(`contentDetail?id=${item.id}`)
                          window.location.href = `profileDetail?id=${item.id}`;
                        }}
                        className="tag cursor-pointer" style={{ fontSize: 12, whiteSpace: 'initial', height: 'auto' }}>
                        <span>{item.firstNameEnglish + " " + item.lastNameEnglish}</span>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </>
      }
      <div className="content container section-item flex-wrap">
        <div className="is-flex">
          <div className="pl-2 is-flex is-align-items-center">
            <img
              className="img-size"
              src={process.env.PUBLIC_URL + "/images/firstPage/Like.png"}
              alt="like"
              width="24"
              height="24"
            />
            <span className="subtitle pl-2">{like ?? 0}</span>
          </div>
          <div className="pl-4 is-flex is-align-items-center">
            <img
              className="img-size"
              src={process.env.PUBLIC_URL + "/images/firstPage/Comment.png"}
              alt="comment"
              width="24"
              height="24"
            />
            <span className="subtitle pl-2">{totalComment}</span>

          </div>

        </div>

      </div>
      <hr className="hr-size" />
      <div className="content container">
        <div
          className="pl-2 is-flex is-align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => {
            func_like();
          }}
        >
          {pIsLike ? (
            <img
              className="img-size"
              src={process.env.PUBLIC_URL + "/images/firstPage/Like.png"}
              alt="Like2"
              width="24"
              height="24"
            />
          ) : (
            <img
              className="img-size"
              src={process.env.PUBLIC_URL + "/images/firstPage/Like2.png"}
              alt="Like2"
              width="24"
              height="24"
            />
          )}
          <span className="subtitle pl-2">{t('text.like')}</span>
        </div>
        <div className="pl-4 is-flex is-align-items-center cursor-pointer">
          <img
            className="img-size"
            src={process.env.PUBLIC_URL + "/images/firstPage/Comment2.png"}
            alt="Comment2"
            width="24"
            height="24"
          />
          <span className="subtitle pl-2">{t('text.comment')}</span>
        </div>
        <div onClick={() => _sharePdf()} className="pl-4 is-flex is-align-items-center cursor-pointer">
          <img
            className="img-size"
            src={process.env.PUBLIC_URL + "/images/firstPage/share.png"}
            alt="Share"
            width="24"
            height="24"
          />
          <span className="subtitle pl-2">{clipboard.copied ? 'คัดลอกสำเร็จ' : t('text.share')}</span>
        </div>
      </div>

      {isComment && <>
        <hr className="hr-size" />
        <form onSubmit={onSubmit}>
          <div className="content container d-flex is-align-items-center">
            <img
              alt={'image_profile'}
              className="is-rounded image-profile-50 mr-3"
              src={imageComment}
            />
            {/* <textarea
              value={state.comment}
              onChange={(e) => {
                if (!(e.target.value.includes('@'))) {
                  setreplyState({ commentId: 0, createby: 0 })
                }
                setstate({ ...state, comment: e.target.value });
              }}

              // dangerouslySetInnerHTML={{ __html: state.comment }}
              className="input is-rounded has-background-light search "
              type="text"
              id="input_comment"
              required
              placeholder={t('text.comment')} /> */}
            <ReactQuill
              className="w-100"
              id="input_comment"
              placeholder={t('text.comment')}
              value={state.comment}
              modules={modules}
              onChange={(content, delta, source, editor) => {
                setstate({ ...state, comment: content });
              }}
            />
            <div className="cursor-pointer" onClick={() => {
              submitEl.current.click();
            }
            }>
              <IconComponent className="icon-20x ml-3" color="#888" icon={faPaperPlane} />
            </div>
            <button type="submit" ref={submitEl} style={{ display: 'none' }}></button>
          </div>
        </form>
      </>
      }
      {
        comments.map((item, index) => {
          return <Comment
            contentid={contentid}
            key={item.id}
            fullName={item.fullNameEng}
            image={item.imageProfile ? process.env.REACT_APP_IMAGE + item.imageProfile : process.env.PUBLIC_URL + "/images/profilePage/Profile.png"}
            comment={item.comment}
            time={ConvertDateShort(item.createdate, "DD MMM YYYY HH:mm น.")}
            item={item}
            isLike={item.isLike}
            reply={reply}
          />
        }
        )
      }
      <div class={`modal ${isModal ? "d-flex" : ""}`}>
        <div class="modal-background"></div>
        <div class="modal-content bg-white p-5" style={{ borderRadius: 5 }}>
          <div className="d-flex-center flex-column">
            <h1>รายงานโพสต์</h1>
            <div className="control flex-column d-flex-center mt-5" style={{ alignItems: 'flex-start', minWidth: 300 }}>
              <label className="radio ml-0" >
                <input defaultChecked={true}
                  onChange={(e) => setspamValue(e.target.value)} type="radio"
                  name="radio-spam" value="spam" />
                สแปม
              </label>
              <label class="radio ml-0">
                <input onChange={(e) => setspamValue(e.target.value)} type="radio" name="radio-spam" value="harassment" />
                ล่วงละเมิดทางเพศ
              </label>
              <label class="radio ml-0">
                <input onChange={(e) => setspamValue(e.target.value)} type="radio" name="radio-spam" value="rules" />
                มีการละเมิดกฏ
              </label>
              <label class="radio ml-0">
                <input onChange={(e) => setspamValue(e.target.value)} type="radio" name="radio-spam" value="spam_other" />
                อื่นๆ
              </label>
              <textarea value={spamNote} onChange={(e) => setspamNote(e.target.value)} placeholder='คำอธิบาย' required rows={4} className='p-2' style={{ width: '100%' }}>

              </textarea>
              {spamFormError && <span className='has-text-danger'>{spamFormError}</span>}
            </div>
            <div className="mt-5 d-flex">
              <button
                onClick={() => {
                  setisModal(false);
                }}
                className="button is-light is-link is-rounded mr-5"
              >
                <div className="font-button">{t("menu.cancel")}</div>
              </button>
              <button
                onClick={(e) => {
                  spamPost(e);
                }}
                className="button is-link is-rounded"
              >
                <div className="font-button">รายงาน</div>
              </button>
            </div>
          </div>
        </div>
        <button onClick={() => {
          setisModal(false);
        }}
          class="modal-close is-large" aria-label="close"></button>
      </div>
    </div >
  );
};

function Badge({ label, type }) {
  const badgeStyles = {
    verified: 'bg-green-500 text-white px-4 py-1 rounded flex items-center gap-2 shadow-md',
    knowledgePath: 'bg-orange-500 text-white px-4 py-1 rounded flex items-center gap-2 shadow-md',
    knowledge: 'bg-blue-600 text-white px-4 py-1 rounded flex items-center gap-2 shadow-md',
};

  const icon = {
    verified: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" width="16" height="16">
        <circle cx="12" cy="12" r="10" fill="white" />
        <path d="M9.75 12.75l1.5 1.5 4.5-4.5" stroke="green" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    knowledgePath: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_1072_91" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1072_91)">
          <path d="M12.6654 14C12.232 14 11.8431 13.875 11.4987 13.625C11.1543 13.375 10.9154 13.0556 10.782 12.6667H7.33203C6.5987 12.6667 5.97092 12.4056 5.4487 11.8833C4.92648 11.3611 4.66536 10.7333 4.66536 10C4.66536 9.26667 4.92648 8.63889 5.4487 8.11667C5.97092 7.59444 6.5987 7.33333 7.33203 7.33333H8.66536C9.03203 7.33333 9.34592 7.20278 9.60703 6.94167C9.86814 6.68056 9.9987 6.36667 9.9987 6C9.9987 5.63333 9.86814 5.31944 9.60703 5.05833C9.34592 4.79722 9.03203 4.66667 8.66536 4.66667H5.21536C5.07092 5.05556 4.82925 5.375 4.49036 5.625C4.15148 5.875 3.76536 6 3.33203 6C2.77648 6 2.30425 5.80556 1.91536 5.41667C1.52648 5.02778 1.33203 4.55556 1.33203 4C1.33203 3.44444 1.52648 2.97222 1.91536 2.58333C2.30425 2.19444 2.77648 2 3.33203 2C3.76536 2 4.15148 2.125 4.49036 2.375C4.82925 2.625 5.07092 2.94444 5.21536 3.33333H8.66536C9.3987 3.33333 10.0265 3.59444 10.5487 4.11667C11.0709 4.63889 11.332 5.26667 11.332 6C11.332 6.73333 11.0709 7.36111 10.5487 7.88333C10.0265 8.40556 9.3987 8.66667 8.66536 8.66667H7.33203C6.96536 8.66667 6.65148 8.79722 6.39036 9.05833C6.12925 9.31945 5.9987 9.63333 5.9987 10C5.9987 10.3667 6.12925 10.6806 6.39036 10.9417C6.65148 11.2028 6.96536 11.3333 7.33203 11.3333H10.782C10.9265 10.9444 11.1681 10.625 11.507 10.375C11.8459 10.125 12.232 10 12.6654 10C13.2209 10 13.6931 10.1944 14.082 10.5833C14.4709 10.9722 14.6654 11.4444 14.6654 12C14.6654 12.5556 14.4709 13.0278 14.082 13.4167C13.6931 13.8056 13.2209 14 12.6654 14ZM3.33203 4.66667C3.52092 4.66667 3.67925 4.60278 3.80703 4.475C3.93481 4.34722 3.9987 4.18889 3.9987 4C3.9987 3.81111 3.93481 3.65278 3.80703 3.525C3.67925 3.39722 3.52092 3.33333 3.33203 3.33333C3.14314 3.33333 2.98481 3.39722 2.85703 3.525C2.72925 3.65278 2.66536 3.81111 2.66536 4C2.66536 4.18889 2.72925 4.34722 2.85703 4.475C2.98481 4.60278 3.14314 4.66667 3.33203 4.66667Z" fill="white" />
        </g>
      </svg>
    ),
    knowledge: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 16 16" width="16" height="16">
        <rect x="6" y="5" width="12" height="14" rx="2" ry="2" stroke="white" strokeWidth="2" fill="none" />
        <path d="M9 8h6m-6 4h4" stroke="white" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  };

  return (
    <div className={badgeStyles[type]}>
      {icon[type]}
      <span className="text-sm">{label}</span>
    </div>
  );
}

export default PostContentGroupDetail;
